import React from 'react';
import { BaseProductCard } from './BaseProductCard';

interface ProductCardProps {
  productId: string;
}

export const ProductCard = ({ productId }: ProductCardProps) => {
  return <BaseProductCard productId={productId} />;
};
